import React from 'react'
import { TNMReportsList } from './TNMReportsList'
import { useNavigate, useParams } from 'react-router-dom'
import { Box, Button, Container, Grid, Typography } from '@mui/material'
import { TimeMaterialCard } from '../../../components/time-material/TimeMaterialCard'
import { Fetching } from '../../../components/Fetching'
import { useGetTMItem } from './hooks'
import { BackButton } from '../../../components/navigation/BackButton'

export const TNMDetail = () => {
  const { id, tmId } = useParams()
  const { data: tmData, isLoading: isTMDataLoading } = useGetTMItem('timematerial', tmId)
  const navigate = useNavigate()

  if (isTMDataLoading) {
    return <Fetching />
  }

  return (
    <>
      <Box sx={{ marginTop: 1, marginLeft: 2, marginRight: 2 }}>
        <Container maxWidth='lg'>
          <BackButton steps={-1}/>
        </Container>
      </Box>
      <Box sx={{ marginTop: 1, marginLeft: 2, marginRight: 2 }}>
        <Container maxWidth='lg'>
          <Typography variant='h4' gutterBottom>
            {tmData?.name}
          </Typography>
          <Grid container spacing={2} alignItems='stretch' sx={{ marginBottom: 2 }}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <TimeMaterialCard timeMaterial={tmData} />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} sx={{ height: '500px'}}>
              <TNMReportsList id={tmId} />
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  )
}
